module.exports = __webpack_public_path__ + "ff1bf552718363ba4601e4e6f6217dac.jpg";